import { Box, Grid, Skeleton, Stack, useTheme } from "@mui/material";
import { v4 as uuid } from "uuid";

interface ListItemSkeletonProps {
  rowCount: number;
  spacing: number;
  widths: (string | number)[];
  heights: (string | number)[];
  style?: {
    container?: React.CSSProperties;
    item?: React.CSSProperties;
    gridContainer?: React.CSSProperties;
    gridItem?: React.CSSProperties;
  };
}
export function DynamicSkeleton(props: ListItemSkeletonProps) {
  const { rowCount, spacing, widths, heights } = props;
  const theme = useTheme();
  return (
    <Box
      p={2}
      bgcolor={theme.palette.grey["200"]}
      borderRadius={"4px"}
      width={"100%"}
      sx={props.style?.container}
    >
      <Grid container spacing={spacing} sx={props?.style?.gridContainer}>
        {Array.from({ length: rowCount }).map((itm, idx) => {
          return (
            <Grid key={uuid()} item xs={12} sx={props?.style?.gridItem}>
              <Skeleton
                sx={{
                  borderRadius: "6px",
                  width: widths[idx],
                  height: heights[idx],
                  transform: "none",
                  ...props?.style?.item,
                }}
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
